@include no-consent;

:host {
    display: block;
    z-index: 1;
    box-sizing: border-box;

    sew-intersection-observer {
        display: block;
        position: relative;
    }

    .custom-controllers {
        width: 100%;
        height: 30px;
        background: transparent;
        z-index: 10;
        position: absolute;
        bottom: 0;
    }
    .progress-bar {
        margin-top: -5px;
        height: 5px;
        background: $color-red;
        width: 0;
        transition: width 0.99s linear;
    }
}

.video-wrapper {
    position: relative;
    box-sizing: border-box;
    line-height: 0;
    height: var(--video-height, 100%);
    aspect-ratio: var(--video-aspect-ratio, unset);
}

.video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 62px;
    background-color: $color-red;
    color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: rgb(0 0 0 / 80%) 0 0 10px;
    pointer-events: none;
}

.caption {
    @include typo-ws-paragraph;

    color: $color-grey-02-steel;
    padding: 8px 0 0;
    margin: 0;

    &.shift-caption-right {
        padding: 8px 0 0 var(--grid-margin);
    }
}

::slotted(sew-picture) {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

:host(.inside-stage) {
    .no-consent {
        padding-left: min(calc(634px + var(--column-gap)), calc(44vw + var(--column-gap)));
        justify-content: start;
    }
}

@include mq-4-min {
    :host(.inside-stage) {
        .no-consent {
            justify-content: start;
            padding-left: 0;
            padding-right: 0;

            .consent {
                position: relative;
                left: 50%;
                // minus half max content width plus max teaser width plus column gap
                transform: translateX(calc(-880px + 634px + var(--column-gap)));
                width: calc(1770px - 634px - var(--column-gap));
            }
        }
    }

    .caption {
        &.shift-caption-right {
            padding-left: 0;
        }
    }
}

@include mq-3-only {
    .caption {
        &.shift-caption-right-mq3 {
            padding: 8px 0 0 var(--grid-margin);
        }
    }
}

@include mq-2 {
    :host(.inside-stage) {
        .no-consent {
            padding-left: calc(50vw + var(--column-gap));
        }
    }
}

@include mq-1 {
    :host(.inside-stage) {
        .no-consent {
            padding: 0 var(--grid-margin);
        }
    }

    .caption {
        &.shift-caption-right {
            padding-left: 0;
        }
    }
}
